<template>
  <div class="pa-login-box-header">
    <div class="img-column img-column-1">
      <LoginText1 />
    </div>

    <div class="img-column img-column-2">
      <div class="login-icon">
        <LoginIcon v-bind:class="loginIconClass" />
      </div>
    </div>

    <div class="img-column img-column-3">
      <LoginText2 />
    </div>
  </div>
</template>

<script>
import LoginText1 from '@/components/FrontParts/LoginModal/LoginBox/Images/login-text1.svg?inlineF'
import LoginText2 from '@/components/FrontParts/LoginModal/LoginBox/Images/login-text2.svg?inlineF'
import LoginIcon  from '@/components/FrontParts/LoginModal/LoginBox/Images/login-icon.svg?inlineN'

export default {
  components : {
    LoginText1,
    LoginText2,
    LoginIcon
  },
  data(){
    return {
      loginIconClass  : {
        'icon-spinning' : false,
      }
    };
  },
  mounted(){
    const vm = this;

    vm.$parent.$on('headerIconSpinning', () => {
      vm.loginIconClass['icon-spinning'] = true;
    });
  }
}
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";

@keyframes spinning
{
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}

.icon-spinning{
  animation-name: spinning;
  animation-duration: 2s;
  animation-iteration-count: 10;
}

div.pa-login-box-header{
  margin:-1px;
  background-color:#89620C;
  display: flex;
  flex-direction: row;

  .img-column{
    text-align: center;
    min-height: 1px;
    line-height:1;

    @include until($tablet) {
      padding-bottom:7px;
    }

    @include from($tablet) {
      padding-bottom:9px;
    }

    background-color:#89620C;

    svg{
      vertical-align: middle;
    }

    &-1, &-3{
      width:40%;

      svg{
        max-width:95%;
      }
    }

    &-2{
      position: relative;
      width:20%;
      line-height:100%;

      div.login-icon{
        position: absolute;
        text-align: center;
        width:100%;
        height:100%;
        left:0;
        z-index: 203;

        img, svg{
          margin-top: -32%;
          max-width: 90%;
          max-width:110px;
          
          .cls-2{
            fill: #c4871a;
          }

          @include from('320px'){
            max-width:58px;
          }

          @include from('375px'){
            max-width:63px;
          }

          @include from('410px'){
            max-width:66px;
          }

          @include from('500px'){
            max-width:90px;
          }

          @include from('600px'){
            max-width:75px;
          }
        }
      }
    }
  }
}
</style>
